/**
 * Created by Florin David on 28.08.2024
 */
export enum ProductFamily {
  scloud = 'scloud',
  splus = 'splus',
  ebs = 'ebs',
  ssalarii = 'ssalarii',
  fluxvision = 'fluxvision',
}
